import * as Yup from 'yup';
import schema from '../questions-form/schema';

const schemaTemplate = Yup.object().shape({
  templateName: Yup.string().required('Required'),
  ...schema.fields,
});

export default schemaTemplate;
